import React from 'react';
import TourCIBCData from '../content/tour-cibc.json';

function TourCibc() {
  return (
    <div
      className="flex min-h-screen flex-col justify-between"
      style={{ backgroundColor: '#fff', fontFamily: 'Kanit, sans-serif' }}
    >
      <header
        className="relative p-[4vw]"
        style={{ backgroundColor: '#003DA5', borderColor: '#003DA5' }}
      >
        <div className="items-right flex items-center justify-between">
          <img
            src={'/images/pema/pema-logo.png'}
            alt="PEMA Logo"
            className="max-h-[9.6vh] min-w-[30vw] max-w-[36vw] object-contain"
          />
          <h2 className="text-[6vw] font-extrabold" style={{ color: '#fff' }}>
            Tour CIBC
          </h2>
        </div>
      </header>

      <div
        className="flex flex-grow flex-col justify-between px-[4vw] py-[3vh]"
        style={{ backgroundColor: '#fff', color: '#003DA5' }}
      >
        <div className="mb-[2vh] flex justify-between">
          <div className="flex flex-col">
            <h2
              className="text-[7vw] font-bold"
              style={{ color: '#003DA5' }}
            >
              Bienvenue !
            </h2>
            <p
              className="text text-[6vw] font-regular leading-none"
              style={{ color: '#00AEEF' }}
            >
              Welcome !
            </p>
          </div>
          <img
            src="/images/pema/logo-fond-blanc-cut.png"
            alt="PEMA P Logo"
            className="h-[17vh] w-[20vh] object-contain"
          />
        </div>

        {/* Arrow pointing to parking entrance */}
        <div className='flex gap-[1vh] flex-col'>
          <div className="mb-[2vh] flex items-center justify-start">
            <img
              src="/images/icons/fleche-bleu.png"
              alt="Arrow"
              className="h-[8vh] w-auto object-contain"
            />
          </div>

          <div className="mb-[2vh] flex justify-between">
            <div className="flex flex-col">
              <h2
                className="text-[11vw] font-bold leading-[80%] mb-[25px]"
                style={{ color: '#003DA5' }}
              >
                Entrée du Stationnement
              </h2>
              <p
                className="text text-[9vw] font-bold leading-none"
                style={{ color: '#00AEEF' }}
              >
                Parking entrance
              </p>
            </div>
          </div>
        </div>

        {/* Payment icons section */}
        <div className="mt-[3vh] flex flex-col justify-between gap-[40px]">
                    <div className="flex gap-[1.5vw]">

            <img
              src="/images/icons/camera.png"
              alt="Camera Surveillance"
              className="h-[6vh] w-[6vh] object-contain"
              style={{ marginRight: '12px' }}
            />

            <img
              src="/images/icons/electric-icon.png"
              alt="Electric Charging"
              className="h-[6vh] w-[6vh] object-contain"
              style={{ marginRight: '12px' }}
            />

            <img
              src="/images/icons/no-nail-wheel.png"
              alt="No Nail Wheel"
              className="h-[6vh] w-[6vh] object-contain"
            />
          </div>
          <div className="flex gap-[1.5vw]">
            <img
              src="/images/payments/mastercard.png"
              alt="Mastercard"
              className="h-[6vh] w-[6vh] object-contain"
              style={{ marginRight: '12px' }}
            />


            <img
              src="/images/payments/visa.png"
              alt="Visa"
              className="h-[6vh] w-[6vh] object-contain"
              style={{ marginRight: '12px' }}
            />

            <img
              src="/images/payments/american-express.png"
              alt="American Express"
              className="h-[6vh] w-[6vh] object-contain"
              style={{ marginRight: '12px' }}
            />

            <img
              src="/images/payments/interact.png"
              alt="Interact"
              className="h-[6vh] w-[6vh] object-contain"
              style={{ marginRight: '12px' }}
            />

            <img
              src="/images/icons/no-cash.png"
              alt="No Cash"
              className="h-[6vh] w-[6vh] object-contain"
            />
          </div>


        </div>
      </div>

      {/* <div className="mb-[4vh] flex flex-col items-center">
        <p
          className="flex flex-col justify-center text-[2.6vh] font-extrabold"
          style={{ color: '#003DA5' }}
        >
          {TourCIBCData.ScreenTextFr.thankForVisit}
        </p>
        <p
          className="text-[2vh] font-bold leading-[1.2]"
          style={{ color: '#00AEEF' }}
        >
          {TourCIBCData.ScreenTextEn.thankForVisit}
        </p>
      </div> */}

      <footer
        className="flex items-center justify-between px-[4vw] py-4"
        style={{ color: '#fff', backgroundColor: '#00AEEF' }}
      >
        <div className="flex flex-col justify-center">
          {/* <p className="text-[6vw] font-extrabold" style={{ color: '#fff' }}>
            {TourCIBCData.ScreenTextFr.phone}
          </p> */}
          <p className="text-[5vw] font-bold" style={{ color: '#fff' }}>
            {TourCIBCData.ScreenTextFr.website}
          </p>
        </div>
        <img
          src="/images/pema/pema-favicon.png"
          alt="PEMA Logo"
          className="h-[7vh] w-[8vh] object-contain"
        />
      </footer>
    </div>
  );
}

export default TourCibc;
